import { useSubscriptionContext } from '../../contexts/SubscriptionContext';
import { useUserContext } from '../../contexts/UserContext';
import { CurrentPlanCard } from './cards/CurrentPlanCard';
import { AddOnModuleCard } from './cards/AddOnModuleCard';
import { MonthlySummaryCard } from './cards/MonthlySummaryCard';
import { ComparePlansTable } from './cards/ComparePlansTable';
import { InvoiceHistoryTable } from './cards/InvoiceHistoryTable';
import { PaymentMethodCard } from './cards/PaymentMethodCard';
import { TrialBanner } from './banners/TrialBanner';
import { PastDueBanner } from './banners/PastDueBanner';
import { MODULE_KEYS_ORDERED } from '../../config/subscriptionConfig';
import { PageHeader } from '../ui';
import '../../css/ManageSubscriptionPage.css';

export const ManageSubscriptionPage = () => {
    const { accountStatus, isTrialActive } = useSubscriptionContext();
    useUserContext();

    return (
        <div className="page-container manage-sub-page">
            {/* Banners */}
            {isTrialActive && <TrialBanner />}
            {accountStatus === 'past-due' && <PastDueBanner />}

            {/* Breadcrumb */}
            <nav className="manage-sub-breadcrumb" aria-label="Breadcrumb">
                <a href="/settings">Settings & Billing</a>
                <span className="manage-sub-breadcrumb-sep">›</span>
                <a href="/settings#subscription">Subscription</a>
                <span className="manage-sub-breadcrumb-sep">›</span>
                <span>Manage Subscription</span>
            </nav>

            <PageHeader
                title="Subscription & Add-Ons"
                subtitle="Manage your plan, add premium modules, and view billing history."
            />

            {/* Current Plan */}
            <CurrentPlanCard />

            {/* Core Program Info */}
            <section className="manage-sub-section">
                <h3 className="manage-sub-section-title">
                    What's in the Core Program
                    <span className="manage-sub-badge-always">ALWAYS INCLUDED</span>
                </h3>
                <p className="manage-sub-section-subtitle">$99/mo flat per company</p>
                <div className="manage-sub-core-features">
                    {[
                        'Inspections & Daily Service',
                        'Equipment Management',
                        'Daily Briefing',
                        'Reports',
                        'User Management',
                        'Resources Library',
                        'Form Templates',
                        'Email Support',
                    ].map((feature) => (
                        <div key={feature} className="manage-sub-core-feature">
                            <span className="manage-sub-check">✓</span>
                            {feature}
                        </div>
                    ))}
                </div>
            </section>

            {/* Premium Add-On Modules */}
            <section className="manage-sub-section">
                <h3 className="manage-sub-section-title">Premium Add-On Modules</h3>
                <p className="manage-sub-section-subtitle">
                    Add modules anytime. Charges are prorated to your next billing date.
                </p>
                <div className="manage-sub-addons-grid">
                    {MODULE_KEYS_ORDERED.map((moduleKey) => (
                        <AddOnModuleCard key={moduleKey} moduleKey={moduleKey} />
                    ))}
                </div>
            </section>

            {/* Compare Plans (show during trial) */}
            {isTrialActive && (
                <section className="manage-sub-section">
                    <ComparePlansTable />
                </section>
            )}

            {/* Billing */}
            <section className="manage-sub-section">
                <h3 className="manage-sub-section-title">Billing</h3>
                <p className="manage-sub-section-subtitle">Payment method, invoice history, and billing contact.</p>
                <div className="manage-sub-billing-grid">
                    <PaymentMethodCard />
                    <MonthlySummaryCard />
                </div>
            </section>

            {/* Invoice History */}
            <section className="manage-sub-section">
                <InvoiceHistoryTable />
            </section>
        </div>
    );
};
